import {StoreStateShape} from '@/redux/store/storeStateTypes';

const getActiveCalls = ({callReducer, commonUserDataReducer}: StoreStateShape) => ({
    activeCalls: callReducer.activeCalls,
    states: commonUserDataReducer?.employment?.states || [],
});

const selectShowVideoCallWidget = ({callReducer: {showVideoCallWidget}}: StoreStateShape) => showVideoCallWidget;
const selectCurrentCallMeetingId = ({callReducer: {currentCallMeetingId}}: StoreStateShape) => currentCallMeetingId;
const selectCurrentCallPatientId = ({callReducer: {currentCallPatientId}}: StoreStateShape) => currentCallPatientId;
const selectMissedCallBellLogsCount = ({callReducer: {missedCallBellLogsCount}}: StoreStateShape) =>
    missedCallBellLogsCount;

export {
    getActiveCalls,
    selectCurrentCallMeetingId,
    selectCurrentCallPatientId,
    selectMissedCallBellLogsCount,
    selectShowVideoCallWidget,
};
